import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Text } from '@ps-design-system/components/Text';
import CheckCircleIcon from '@ps-design-system/icons/CheckCircle/CheckCircle20';
import XCircleIcon from '@ps-design-system/icons/XCircle/XCircle20';

const PauseReasons = () => {
  return (
    <div className="pause-reasons-container">
      <div className="pause-reason">
        <div className="pause-icon"><XCircleIcon /></div>
        <div>
          <Text typeface="body-1">
            <FormattedMessage id="pause.modal.hidden" defaultMessage="Hidden from search"/>
          </Text>
        </div>
      </div>
      <div className="pause-reason">
        <div className="pause-icon"><XCircleIcon /></div>
        <div>
          <Text typeface="body-1">
            <FormattedMessage id="pause.modal.activate" defaultMessage="No booking requests and inquiries"/>
          </Text>
        </div>
      </div>
      <div className="pause-reason">
        <div className="pause-icon"><CheckCircleIcon /></div>
        <div>
          <Text typeface="body-1">
            <FormattedMessage id="pause.modal.easy" defaultMessage="Easy to activate"/>
          </Text>
        </div>
      </div>
    </div>
  );
};

export default PauseReasons;
